import { render } from "./CommonRadio.vue?vue&type=template&id=4195f6b9&scoped=true"
import script from "./CommonRadio.vue?vue&type=script&lang=js"
export * from "./CommonRadio.vue?vue&type=script&lang=js"

import "./CommonRadio.vue?vue&type=style&index=0&id=4195f6b9&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4195f6b9"

export default script